import { useDispatch } from "react-redux";
import { setSidebar } from "../../../../app/appSlice";
import { useLazyViewSourceQuery, useStateMutation } from "../../cdsApiSlice";
import {
  logMessage,
  stateMessage,
} from "../../cdsApiSlice";
import { DataSourceExterneDetail } from "./DataSourceExterneDetail";

const useRedirectToDetailSourceExterne = () => {
  const dispatch = useDispatch();
  const [getSource,] =
    useLazyViewSourceQuery();

  const [getState] = useStateMutation();

  const getStateSourceExterneAndOpenDetails = async (id: number,source:any) => {
    try {
      const data = await getState({ id: id }).unwrap();
      dispatch(
        setSidebar({
          title: "",
          content: (
            <DataSourceExterneDetail
              id={id}
              logMessage={logMessage(data)}
              message={stateMessage(data)}
              state={data}
              sourceView={source}
            />
          ),
        })
      );
    } catch {
      console.error("error api state source externe !");
    }
  };

  const callDetailSourceExterne = async (id: number) => {
    try {
      const sourceView =  await getSource({ id: id }).unwrap();
      getStateSourceExterneAndOpenDetails(id,sourceView)
    } catch {
      console.error("error api state source externe !");
    }
  };

  return {
    callDetailSourceExterne,
  };
};

export default useRedirectToDetailSourceExterne;
